import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {HolidayComponent} from './holiday/holiday.component';
import {AdminComponent} from './admin.component';
import {RSSTransactionsComponent} from './rsstransactions/rsstransactions.component';
import {PostPurchaseAdjustmentsComponent} from './post-purchase-adjustments/post-purchase-adjustments.component';
import {GseLimitComponent} from './gse-limit/gse-limit.component';
import {FHAMaxClaimAmountComponent} from './fhamax-claim-amount/fhamax-claim-amount.component';
import {ReportsComponent} from './reports/reports.component';
import {MonthlyReportsComponent} from './monthly-reports/monthly-reports.component';
import {OldMonthlyReportsComponent} from './old-monthly-reports/old-monthly-reports.component';
import {UpdateSeasonLoanFeeComponent} from './update-season-loan-fee/update-season-loan-fee.component';
import {UpdateSystemAttributesComponent} from './update-system-attributes/update-system-attributes.component';
import {UpdateDeveloperAttributesComponent} from './update-developer-attributes/update-developer-attributes.component';
import {PostpurchaseupdateComponent} from './post-purchase-adjustments/postpurchaseupdate/postpurchaseupdate.component';
import {AppComponent} from '../../app.component';
import {SharedModule} from '../../shared/shared.module';

@NgModule({
  declarations: [
    HolidayComponent,
    AdminComponent,
    RSSTransactionsComponent,
    PostPurchaseAdjustmentsComponent,
    GseLimitComponent,
    FHAMaxClaimAmountComponent,
    ReportsComponent,
    MonthlyReportsComponent,
    OldMonthlyReportsComponent,
    UpdateSeasonLoanFeeComponent,
    UpdateSystemAttributesComponent,
    UpdateDeveloperAttributesComponent,
    PostpurchaseupdateComponent
  ],
  imports: [
    SharedModule,
    CommonModule
  ],
  exports: [],
  providers: [DecimalPipe],
  bootstrap: [AppComponent]
})
export class AdminModule {
}
